import React, { useState, useEffect } from 'react';

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  const next = () => setCurrentIndex((prev) => (prev + 1) % screens.length);
  const prev = () => setCurrentIndex((prev) => (prev - 1 + screens.length) % screens.length);

  const screens = [
    {
      src: 'Screenshot1.png',
      alt: 'Game Menu Screen',
      title: 'Simple Menu',
      caption: 'Clean interface to quickly start or join a game'
    },
    {
      src: 'Screenshot2.png',
      alt: 'Game Map',
      title: 'Interactive Map',
      caption: 'Real-time tracking of chickens across London pubs'
    },
    {
      src: 'Screenshot3.png',
      alt: 'Game Setup',
      title: 'Flexible Setup',
      caption: 'Customize player counts, teams, and game duration'
    },
    {
      src: 'Screenshot4.png',
      alt: 'Team Assignment',
      title: 'Team Balancing',
      caption: 'Smart team distribution for fair gameplay'
    },
    {
      src: 'Screenshot5.png',
      alt: 'Role Assignment',
      title: 'Role Selection',
      caption: 'Unique gameplay mechanics for Chasers and Chickens'
    },
    {
      src: 'Screenshot6.png',
      alt: 'Game Chat',
      title: 'In-Game Chat',
      caption: 'Real-time communication between team members'
    },
    {
      src: 'Screenshot7.png',
      alt: 'Game Over',
      title: 'Victory Screen',
      caption: 'Track your success and game statistics'
    }
  ];

  

  useEffect(() => {
    if (isPlaying) {
      const interval = setInterval(4000);
      return () => clearInterval(interval);
    }
  }, [isPlaying]);


  return (
    <section id="gallery" className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-medium text-gray-800 mb-12 text-center">Gallery</h2>
        
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 items-center bg-gray-100 rounded-2xl p-8 relative">
            <div className="lg:w-1/3 flex justify-center px-12">
              <div className="relative w-[280px]">
                <img
                  src={screens[currentIndex].src}
                  alt={screens[currentIndex].alt}
                  className="w-full rounded-xl shadow-lg"
                />
              </div>
            </div>

            <div className="lg:w-2/3 lg:pl-8">
              <h3 className="text-2xl font-medium text-gray-800 mb-4">
                {screens[currentIndex].title}
              </h3>
              <p className="text-lg text-gray-600 mb-8">
                {screens[currentIndex].caption}
              </p>
              
              <div className="flex gap-2 mb-4">
                {screens.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`w-3 h-3 rounded-full transition-all duration-300 ${
                      currentIndex === index ? 'bg-blue-500 w-6' : 'bg-gray-300'
                    }`}
                  />
                ))}
              </div>

              <button
                onClick={() => setIsPlaying(!isPlaying)}
                className="text-gray-600 hover:text-gray-800 transition"
              >
                {isPlaying ? 'Pause' : 'Play'} Slideshow
              </button>
            </div>

            <button onClick={prev} className="absolute left-4 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 text-white p-3 rounded-full hover:bg-opacity-75 transition">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            
            <button onClick={next} className="absolute right-4 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 text-white p-3 rounded-full hover:bg-opacity-75 transition">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;